import type { JSX, ReactNode } from "react";
import "./ContentHeader.scss";

interface ContentHeaderProps {
  title: string | ReactNode;
  actions?: ReactNode;
  showActions?: boolean;
  headingLevel?: 1 | 2 | 3 | 4 | 5 | 6;
  className?: string;
}

const ContentHeader = ({
  title,
  actions,
  showActions = true,
  headingLevel = 2,
  className = "",
}: ContentHeaderProps) => {
  const HeadingTag = `h${headingLevel}` as keyof JSX.IntrinsicElements;

  return (
    <div className={`content-header ${className}`}>
      <div className="content-header__content">
        <HeadingTag className="content-header__title">{title}</HeadingTag>
        {actions && showActions && (
          <div className="content-header__actions">{actions}</div>
        )}
      </div>
    </div>
  );
};

export default ContentHeader;
